import "./img-list-container.comp.scss";
import { HomeMainCompProps } from "../home-main-comp/home-main.comp";

const ImgListContainer = ({ homeMainCompData }: HomeMainCompProps) => {
  return (
    <aside
      className={`img-list-container ${homeMainCompData.label}-list-field`}
    >
      {homeMainCompData.imgList.map((d) => (
        <div className={`img-list-item`} key={d.title}>
          <div
            className={`img-wrapper ${
              d.img.toLowerCase().includes("tv") && "onTV"
            } ${d.img.toLowerCase().includes("agrad") && "withAgrad"} ${
              d.img.toLowerCase().includes("bezara") && "withBezara"
            } ${d.img.toLowerCase().includes("feno.") && "feno"}`}
            style={{ backgroundImage: `url(${d.img})` }}
            onClick={() => {
              window.open(d.link ? d.link : d.img, "_blank", "fullscreen=0");
            }}
          >
            <div className={`progress-bar-container`}>
              <div className={`progress-bar`}></div>
            </div>
          </div>
          <div className="text-wrapper">
            <h3>{d.title}</h3>
            <p
              onClick={() => {
                window.open(d.link ? d.link : d.img);
              }}
            >
              {d.text}
            </p>
          </div>
        </div>
      ))}
    </aside>
  );
};

export default ImgListContainer;
